import { FC, Fragment, ReactElement } from 'react';

import { RaaExpandablePreview } from 'raa-react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';

import { Skyddsbestammelse } from 'models';

import { renderWithParagraphs } from 'utilities/renderWithParagraphs';

interface BebyggelseSkyddstypSectionProps {
  skyddsbestammelser?: Array<Skyddsbestammelse>;
  sammansattParentId?: string | null;
}

const BebyggelseSkyddstypSection: FC<BebyggelseSkyddstypSectionProps> = ({
  sammansattParentId,
  skyddsbestammelser
}): ReactElement => (
  <DrawerSection>
    <h2 className="tw-heading-md tw-mb-4">Skyddsbestämmelser</h2>

    {!skyddsbestammelser?.length && <>&ndash;</>}

    {skyddsbestammelser && (
      <RaaExpandablePreview height={94} ariaLabel="Skyddsbestämmelser">
        {sammansattParentId && <p>Se ovanstående länk</p>}

        {!sammansattParentId && (
          <div className="tw-my-2">
            {skyddsbestammelser.map((skyddsbestammelse) => (
              <Fragment key={skyddsbestammelse.attribut_id}>
                <h3 className="tw-font-semibold">{skyddsbestammelse.rubrik}</h3>
                <div className="tw-mb-4">{renderWithParagraphs(skyddsbestammelse.skyddsbestammelse) || '–'}</div>
              </Fragment>
            ))}
          </div>
        )}
      </RaaExpandablePreview>
    )}
  </DrawerSection>
);

export default BebyggelseSkyddstypSection;
